import { render } from "./GroupsListView.vue?vue&type=template&id=25d45ebc&scoped=true&ts=true"
import script from "./GroupsListView.vue?vue&type=script&lang=ts"
export * from "./GroupsListView.vue?vue&type=script&lang=ts"

import "./GroupsListView.vue?vue&type=style&index=0&id=25d45ebc&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d45ebc"]])

export default __exports__